import { FormValueConverter } from "../FormField";
import { CurrencyUtil } from "@eres/core";

class PercentConverter implements FormValueConverter<string> {
	maxPercentage: number = 100;

	constructor( maxPercentage?: number ) {
		if ( maxPercentage )
			this.maxPercentage = maxPercentage;
	}

	toData( text: string ): string | null {
		const valStr = CurrencyUtil.convertCurrencyToValue( text );
		const valNum = valStr ? Number.parseFloat( valStr ) : 0;
		if ( valNum < this.maxPercentage )
			return valStr ? "" + valStr : "";
		else
			return "" + this.maxPercentage;
	}

	toText( data: string ): string | null {
		return data;
	};
}

const Converter = new PercentConverter();
export default Converter;
